
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner/google/learn-ai/[[...slug]]",
      function () {
        return require("private-next-pages/partner/google/learn-ai/[[...slug]].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partner/google/learn-ai/[[...slug]]"])
      });
    }
  